import React from 'react';

/** Why an email was retired unsent, by the backend's metadata.skip_reason. */
const SKIP_REASONS = {
	recipient_deactivated: 'The recipient account is deactivated.',
	recipient_not_activated: 'The recipient is not verified and approved.',
	recipient_unsubscribed: 'The recipient unsubscribed from email.',
	recipient_emails_paused: 'The recipient paused email.',
	recipient_muted: 'The recipient muted notifications.',
	recipient_no_email: 'The recipient has no email address.',
	recipient_suppressed: 'Amazon SES suppressed the recipient address after a bounce or complaint.',
	no_recipient_mailed: 'No recipient was mailed.',
};

const STATUS_CLASSES = {
	pending: 'bg-warning',
	sent: 'bg-success',
	failed: 'bg-danger',
};

/**
 * An email's status as a badge, for the table and the details modal alike. A
 * pending email the sender retired unsent shows as skipped, with its reason as
 * a tooltip, or beside it when showReason is set.
 */
const EmailStatusBadge = ({ email, showReason = false }) => {
	const skipReason = email.metadata?.skip_reason;
	if (email.status === 'pending' && skipReason) {
		const reason = SKIP_REASONS[skipReason] || skipReason;
		return (
			<>
				<span className="badge bg-secondary" title={reason}>
					skipped
				</span>
				{showReason && <small className="text-muted ms-2">{reason}</small>}
			</>
		);
	}

	return (
		<span className={`badge ${STATUS_CLASSES[email.status] || 'bg-secondary'}`}>
			{email.status}
		</span>
	);
};

export default EmailStatusBadge;
